<template>
  <div class="container">
    <div class="title">
      <p class="words">营业额(元)</p>
    </div>
    <div class="tips flex">
      <div class="flex-row">
        <div style="width:12px;height:12px;background: #00ECFC;margin-right: 5px;"></div>
        <div>营业额</div> 
      </div>
      <div class="flex-row">
        <div style="width:12px;height:12px;background: #30BC74;border-radius: 2px;margin-right: 5px;"></div>
        <div>电费</div>
      </div>
      <div class="flex-row">
        <div style="width:12px;height:12px;background: #F7B500;border-radius: 2px;margin-right: 5px;"></div>
        <div>服务费</div>
      </div>
    </div>
    <div id="chart" ref="main" style="width: 100%; height: 150px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea: null,
      xData: [],
      yData: [],
      lightData: [],
      serveList: [],
      eleList: [],
    };
  },
  props: {
    level: "",
    regionId: "",
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
      this.getoption5Data();
    },
    getoption5Data() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getTurnoverTotal"),
        method: "get",
        params: this.$http.adornParams({
          findType: 1,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data, "营业额营业额");
        this.xData = [];
        this.yData = [];
        this.lightData = [];
        this.eleList = [];
        this.serveList = [];
        if (data.code == 0) {
          this.xData = data.data.keys;
          this.yData = data.data.values1;
          this.eleList = data.data.values2;
          this.serveList = data.data.values3;
          data.data.keys.forEach((item, index) => {
            this.lightData.push([item, data.data.values1[index]]);
          });
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      
      var XName = this.xData;
      var data1 = this.yData;
      var ServeList = this.serveList;
      var EleList = this.eleList;
      const option = {
        // backgroundColor: "#0e2147",
        grid: {
          left: "5%",
          top: "10%",
          bottom: "10%",
          right: "5%",
        },
        legend: {
          show: false,
          data: ["3", "1", "2"],
          right: 10,
          top: 0,
          itemWidth: 18,
          itemHeight: 12,
          textStyle: {
            color: "#00ffff",
            fontSize: 14,
          },
        },
        yAxis: [
          {
            type: "value",
            position: "left",
            nameTextStyle: {
              color: "#00FFFF",
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(135,140,147,0.8)",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: function (value) {
                value = value.toString();
                if (value >= 1000000) {
                  return value.substring(0, 4) / 10 + "万";
                } else if (value >= 800000) {
                  return value.substring(0, 3) / 10 + "万";
                } else if (value >= 400000) {
                  return value.substring(0, 3) / 10 + "万";
                } else if (value >= 200000) {
                  return value.substring(0, 3) / 10 + "万";
                } else if (value >= 100000) {
                  return value.substring(0, 3) / 10 + "万";
                } else if (value >= 50000) {
                  return value.substring(0, 2) / 10 + "万";
                } else {
                  return 0;
                }
              },
              color: "#fff",
              fontSize: 10,
            },
          },
        ],
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0696f9",
              },
            },
            axisLabel: {
              inside: false,
              textStyle: {
                color: "#fff", // x轴颜色
                fontWeight: "normal",
                fontSize: "10",
                lineHeight: 5,
              },
            },
            data: XName,
          },
        ],
        series: [
        {
            name: "营业额",
            type: "line",
            data:data1,
            symbol: "emptyCircle",
            symbolSize: 6,
            showSymbol: true,
            itemStyle:{
              normal:{
                color:"rgba(0, 236, 252, 1)"
              }
            },
            lineStyle:{
              normal:{
                with:5,
                color:"rgba(0, 236, 252, 1)"
              }
            }
          },
          {
            name: "1",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: "#FFF8C8",
                  },
                  {
                    offset: 0,
                    color: "#F7B500",
                  },
                ]),
                barBorderRadius: [10, 10, 0, 0],
              },
            },
            data: ServeList,
          },
          {
            name: "2",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: "#AEF2D6",
                  },
                  {
                    offset: 0,
                    color: "#30BC74",
                  },
                ]),
                barBorderRadius: [10, 10, 0, 0],
              },
            },
            data: EleList,
          },
        ],
      };
      this.echartArea.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;
  position: relative;
  .tips{
    position: absolute;
    right: 20px;
    top:15px;
    display: flex;
    .flex-row{
      // height: 20px;
      line-height: 20px;
      margin-left: 10px;
      color: #fff;
      font-size: 10px;
      display: flex;
      align-items: center;
    }
  }
}
.title {
  width: 140px;
  height: 28px;
  line-height: 28px;
  background-image: url("../../assets/title-bg.png");
  background-size: 100% 100%;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #00ecfc;
  position: relative;
  .words {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 280px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/option5.vue